// extracted by mini-css-extract-plugin
export default {"forecastTableTableWrap":"ncQDfjChIeVAh_otxnW8","forecastTableTable":"sl9s3Fae6JMMEvKrRwDT"};